// @flow
import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter, Route } from 'react-router-dom'
import I18n from 'i18n-react'

import { persistStore } from 'redux-persist/lib'

import ProductActions from '../Core/Redux/ProductRedux'

// config
import { config } from '../Config/ConfigLoader'

import RootContainer from './RootContainer'
import { getLinkIdFromUrl } from '../Core/LinkIdFunctions'

import SuriApi from '../Services/SuriApi.js'

// types
type Props = {
  affiliate: string,
  basename: string,
  isPreloadedState: boolean,
  store: any,
  token: string,
}

export default class AppContainer extends React.Component<Props> {
  constructor(props) {
    super(props)

    I18n.setTexts(config.getDefaultTranslations())
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    const { basename, store, token, affiliate, turnOffHydrate, subProductName } = this.props
    const persistor = persistStore(store, null, () => {
      store.dispatch(ProductActions.afterRehydratation())
    })

    if (token) {
      SuriApi.setHeader('Authorization', `Bearer ${token}`)
    }

    let linkId = getLinkIdFromUrl(config.getConfig('isBackOffice'))

    return (
      <Provider store={store}>
        <div className="site">
          <BrowserRouter basename={basename}>
            <Route
              path="/"
              render={(props) => {
                return (
                  <RootContainer
                    affiliate={affiliate}
                    key="root"
                    linkId={linkId}
                    subProductName={subProductName}
                    token={token}
                    turnOffHydrate={turnOffHydrate}
                    {...props}
                  />
                )
              }}
            />
          </BrowserRouter>
        </div>
      </Provider>
    )
  }
}
